import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider, Button} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import InventoryitemInfo from './InventoryitemInfo';
import IconEnabled from 'core/components/layout/IconEnabled';
import { transformDateValue } from 'core/js/FormUtils';


export default function InventoryitemListTableRow({obj, getActionComponent,actionList,handleRowClick}){
  const {mobileView} = useSelector((state)=>state.menu);
  const {inventoryObj} = useSelector((state)=>state.manufslice.inventoryDashboard);
  useEffect(()=>{
  },[])
  const getHoverColor = () =>{
    if (mobileView) return ''
    return 'primary.main';
  }
  const getHoverBackgroundColor = () =>{
    if (mobileView) return ''
    return 'secondary.200';
  }
  const getBackgroundColor = (obj) =>{
    if (mobileView) {
      if (obj.expand) return 'secondary.500'
      return 'white'
    }
    return 'white'
  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  
              backgroundColor: getBackgroundColor(obj),
              color: mobileView && obj.expand?'primary.main':'primary.darker',
              '&:hover': {
                backgroundColor: getHoverBackgroundColor, 
                color: getHoverColor()
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={2} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.partyname===''?obj.title:obj.partyname}</Typography></Grid>
              {mobileView?<></>:
              <>
              <Grid item lg={1} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderid}</Typography></Grid>
              <Grid item lg={2} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{transformDateValue(obj.editTimestamp)}</Typography></Grid>
              </>
              
              }
              <Grid item lg={1} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.type?obj.creditcount:''}</Typography></Grid>
              <Grid item lg={1} xs={3} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.type?'':obj.debitcount}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.balance}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>
              
              <Grid item lg={2} xs={1} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {inventoryObj.credititemid==obj.id?
                  <IconEnabled key={`${obj.id}-${actionList[0].title}`} actionObj={actionList[0]} id={obj.id} />
                  :<></>}
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        {/* <Grid item lg={12} sx={{ width: '100%' }}><Divider/></Grid> */}
        {obj.expand ?
        <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            < InventoryitemInfo  inventoryitemObj={obj} />
          </Grid>
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>}
      </>
      
    )
}